module.exports = __webpack_public_path__ + "img/book-pic.aac80db1.svg";